const cookiesConstants = {
  COOKIES: {
    COUNTRY_CODE: {
      name: 'countryCode',
      options: {
        maxAge: 1000 * 60 * 60 * 24 * 30, // 30 días
        httpOnly: true,
        sameSite: 'lax' as boolean | 'lax' | 'strict' | 'none' | undefined,
        secure: process.env.NODE_ENV === 'production',
        path: '/',
      },
      values: {
        DE: 'DE',
        EN: 'EN',
      },
    },
    DEVICE_TYPE: {
      name: 'deviceType',
      options: {
        maxAge: 1000 * 60 * 60 * 24 * 30, // 30 días
        httpOnly: true,
        sameSite: 'lax' as boolean | 'lax' | 'strict' | 'none' | undefined,
        secure: process.env.NODE_ENV === 'production',
        path: '/',
      },
      values: {
        APPLE: 'apple',
        OTHER: 'other',
      },
    },
    IP: {
      name: 'ip',
      options: {
        maxAge: 1000 * 60 * 60 * 24 * 30,
        httpOnly: true,
        sameSite: 'lax' as boolean | 'lax' | 'strict' | 'none' | undefined,
        secure: process.env.NODE_ENV === 'production',
        path: '/',
      },
    },
    FESTIVAL_VOUCHER: {
      name: 'festivalVoucher',
    },
    REFERRAL_CODE: {
      name: 'referral_code',
      options: {
        maxAge: 60 * 60 * 24 * 7,
        path: '/',
      },
    },
    VOUCHER_FESTIVAL: {
      name: 'voucherFestival',
    },
    PRICE_RANGE_SKU_MAX: {
      name: 'sku_price_range_min',
    },
    PRICE_RANGE_SKU_MIN: {
      name: 'sku_price_range_max',
    },
    FILTERS_ARE_OPEN: {
      name: 'filtersAreOpen',
    },
    USER_BROWSER_LOCALE: {
      name: 'userBrowserLocale',
      options: {
        maxAge: 60 * 60 * 24 * 7,
        path: '/',
      },
    },
    TAX_ID_VERIFIED: {
      name: 'taxIdVerified',
      options: {
        maxAge: 60 * 60 * 24 * 7,
        path: '/',
      },
    },
    TAX_NUMBER_REQUIRED: {
      name: 'taxNumberRequired',
      options: {
        maxAge: 60 * 60 * 24 * 7,
        path: '/',
      },
    },
    KLAVIYO_LIMITED_SPECIAL_OFFER: {
      name: 'klaviyo_limited_special_offer',
    },
    MARKETING_SIGN_UP: {
      name: 'marketing_sign_up',
    },
    AUTH_TOKENS: {
      name: 'authTokens',
      options: {
        maxAge: 604800,
        priority: 'high',
        sameSite: 'lax',
        path: '/',
        httpOnly: true,
        secure: process.env.NODE_ENV === 'production',
      },
    },
    RETURN_TO: {
      name: 'returnTo',
    },
    NEXT_LOCALE: {
      name: 'NEXT_LOCALE',
      options: {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
        httpOnly: false,
        secure: process.env.NODE_ENV === 'production',
      },
    },
    ONBOARDING: {
      name: 'onboarding',
    },
    NO_ONBOARDING: {
      name: 'noOnboarding',
    },
    WINDOW_WIDTH: {
      name: 'windowWidth',
    },
    MESSAGE: {
      name: 'message',
    },
    WAIT_VERIFICATION: {
      name: 'waitVerification',
    },
    USER: {
      name: 'user',
    },
    SESSION_TOKEN: {
      name: 'sessionToken',
      options: {
        maxAge: 30 * 24 * 60 * 60 * 1000, // 30 days in ms
        httpOnly: false,
        secure: process.env.NODE_ENV === 'production',
        path: '/',
        priority: 'high',
      },
    },
    LANGUAGE_MODAL: {
      name: 'languageModal',
      options: {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
        httpOnly: false,
        secure: process.env.NODE_ENV === 'production',
      },
    },
    LANGUAGE_MODAL_DISMISSED: {
      name: 'languageModalDismissed',
      options: {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
      },
    },
    RETURN_AFTER_ONBOARDING: {
      name: 'returnAfterOnboarding',
      options: {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
      },
    },
    FIRST_VISIT_DONE: {
      name: 'first_visit_done',
      options: {
        maxAge: 31536000,
        path: '/',
      },
    },
  },
};

export default cookiesConstants;
